/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginWithPasswordRequest } from '../../models/login-with-password-request';
import { LoginWithPasswordResult } from '../../models/login-with-password-result';

export interface PostLogin$Params {
  body?: LoginWithPasswordRequest;
}

export function postLogin(
  http: HttpClient,
  rootUrl: string,
  params?: PostLogin$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<LoginWithPasswordResult>> {
  const rb = new RequestBuilder(rootUrl, postLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginWithPasswordResult>;
    }),
  );
}

postLogin.PATH = '/Authentication/login';
